/* assets/cart-gift.js — Free gift progress + leaner cart sync */
(function () {
  // ---------- tiny helpers ----------
  const $  = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const debounce = (fn, ms = 140) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
let _lastTierStage = null;     // 0,1,2
let _domRefreshLock = false;   // prevents loops while we refresh
  // 1) Deduplicate /cart.js reads (coalesce concurrent calls)
  let _cartInflight = null;
  async function fetchCart() {
    if (_cartInflight) return _cartInflight;
    _cartInflight = fetch('/cart.js', { headers: { 'Accept': 'application/json' }})
      .then(r => r.json())
      .finally(() => { _cartInflight = null; });
    return _cartInflight;
  }

  // --- UI busy state for gift add ---
  let giftAddLock = false;
  let lockedBtn   = null;
  let giftsBusy   = false;

function setGiftsBusy(isBusy, exceptBtn = null) {
  const ctx = getContext();
  if (!ctx) return;

  ctx.giftsWrap.dataset.busy = isBusy ? 'true' : 'false';

  // tag/untag the active button so CSS won't block it
  if (exceptBtn) {
    if (isBusy) exceptBtn.setAttribute('data-busy-exempt', 'true');
    else        exceptBtn.removeAttribute('data-busy-exempt');
  } else {
    $$('[data-add-gift][data-busy-exempt]', ctx.giftsWrap).forEach(b => b.removeAttribute('data-busy-exempt'));
  }

  // hard-disable all the *other* gift buttons instantly
  $$('[data-add-gift]', ctx.giftsWrap).forEach(b => {
    if (exceptBtn && b === exceptBtn) return;
    b.disabled = !!isBusy;
    b.classList.toggle('gift-is-disabled', !!isBusy); // Changed from 'is-disabled'
    if (isBusy) b.setAttribute('aria-disabled', 'true');
    else        b.removeAttribute('aria-disabled');
  });
}

function applyBusyState(root = document) {
  const wrap = root.querySelector('.quick-cart [data-gifts]');
  if (!wrap) return;

  if (giftsBusy) {
    wrap.setAttribute('data-busy', 'true');
    wrap.querySelectorAll('[data-add-gift]').forEach(b => {
      b.disabled = true;
      b.classList.add('gift-is-disabled'); // Changed from 'is-disabled'
      b.setAttribute('aria-disabled', 'true');
    });
  } else {
    wrap.removeAttribute('data-busy');
  }
}

  /** Ensure total gift qty never exceeds ctx.maxGifts (safety net) */
async function trimGiftsToMax(cart, ctx) {
  const state = calcFromCart(cart, ctx);
  
  // Detect tier change and refresh DOM
  const stageNow = state.tier2 ? 2 : (state.tier1 ? 1 : 0);
  if (_lastTierStage !== null && stageNow !== _lastTierStage && !_domRefreshLock) {
    try {
      _domRefreshLock = true;
      await refreshQuickCartDOM();
    } finally {
      _domRefreshLock = false;
    }
  }
  _lastTierStage = stageNow;

  const max = state.liveMax || 0;
  const items = (cart && cart.items) || [];
  
  // Count actual gifts in cart
  let totalGift = 0;
  items.forEach(i => { if (i?.properties?._gift === 'true') totalGift += i.quantity; });
  
  // ONLY set the attribute if there are actual gifts in the cart
  // Otherwise, clear it
  if (totalGift > 0) {
    await setGiftMaxAttribute(max);
  } else {
    await setGiftMaxAttribute(0); // This will clear the attribute
  }

  if (totalGift <= max) return false;

  // Trim logic remains the same
  let remaining = max;
  for (const i of items) {
    if (i?.properties?._gift === 'true') {
      const newQty = Math.max(0, Math.min(i.quantity, remaining));
      remaining -= newQty;
      if (newQty !== i.quantity) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: i.key, quantity: newQty })
        });
      }
    }
  }
  return true;
}


  // 4) Guarded carousel init (don’t bind listeners repeatedly)
  function initGiftCarousel() {
    const root = document.querySelector('.quick-cart');
    if (!root) return;

    document.querySelectorAll('.cart-gifts').forEach(g => {
      if (g.dataset.carouselInit === '1') return;
      g.dataset.carouselInit = '1';

      const vp    = g.querySelector('[data-gifts-viewport]');
      const prev  = g.querySelector('.cart-gifts__nav--prev');
      const next  = g.querySelector('.cart-gifts__nav--next');
      const track = g.querySelector('.cart-gifts__track');
      const card  = g.querySelector('.cart-gifts__item');
      if (!vp || !prev || !next || !track) return;

      const gapPx = () => {
        const cs = getComputedStyle(track);
        return parseFloat(cs.columnGap || cs.gap) || 12;
      };
      const cardStep = () => {
        const w = card ? card.getBoundingClientRect().width : 0;
        return w ? w + gapPx() : Math.max(240, Math.floor(vp.clientWidth * 0.9));
      };

      const updateArrows = () => {
        const maxScroll = vp.scrollWidth - vp.clientWidth - 1;
        prev.disabled = vp.scrollLeft <= 0;
        next.disabled = vp.scrollLeft >= maxScroll;
      };

      prev.addEventListener('click', () => {
        vp.scrollBy({ left: -cardStep(), behavior: 'smooth' });
        setTimeout(updateArrows, 200);
      });
      next.addEventListener('click', () => {
        vp.scrollBy({ left:  cardStep(), behavior: 'smooth' });
        setTimeout(updateArrows, 200);
      });

      vp.addEventListener('scroll', () => requestAnimationFrame(updateArrows));
      window.addEventListener('resize', () => setTimeout(updateArrows, 50), { passive:true });

      updateArrows();
    });
  }

  function formatMoneyIntl(cents, currencyCode) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }).format(cents / 100); }
    catch { return (cents / 100).toFixed(2); }
  }

function getContext() {
  const root = document.querySelector('.quick-cart');
  if (!root) return null;
  const giftsWrap  = root.querySelector('[data-gifts]');
  const labelEl    = root.querySelector('[data-progress-label]');
  const fillEl     = root.querySelector('[data-progress-fill]');
  if (!giftsWrap || !labelEl || !fillEl) return null;

  const shipThresholdCents = Math.round(parseFloat(giftsWrap.dataset.thresholdShip || '0') * 100);
  const g1Cents            = Math.round(parseFloat(giftsWrap.dataset.thresholdG1   || '0') * 100);
  const g2Cents            = Math.round(parseFloat(giftsWrap.dataset.thresholdG2   || '0') * 100);
  const max1               = parseInt(giftsWrap.dataset.max1 || '1', 10);
  const max2               = parseInt(giftsWrap.dataset.max2 || '2', 10);

  return {
    root, giftsWrap, labelEl, fillEl,
    shipThresholdCents,
    gift1ThresholdCents: g1Cents,
    gift2ThresholdCents: g2Cents,
    max1, max2
  };
}

function calcFromCart(cart, ctx) {
  let subtotalExGifts = 0;
  let giftCount = 0;
  const giftVariantIds = new Set();
  const paidVariantIds = new Set(); // CHANGED: Only track PAID variants

  (cart.items || []).forEach(i => {
    const isGift = i.properties && i.properties._gift === 'true';
    
    if (isGift) {
      giftCount += i.quantity;
      giftVariantIds.add(i.variant_id);
    } else {
      // Only add to paidVariantIds if it's NOT a gift
      paidVariantIds.add(i.variant_id); // CHANGED
      subtotalExGifts += i.final_line_price;
    }
  });

  const currency  = cart.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  const awayShip  = Math.max(ctx.shipThresholdCents - subtotalExGifts, 0);
  const awayG1    = Math.max(ctx.gift1ThresholdCents - subtotalExGifts, 0);
  const awayG2    = Math.max(ctx.gift2ThresholdCents - subtotalExGifts, 0);

  const tier1     = subtotalExGifts >= ctx.gift1ThresholdCents;
  const tier2     = subtotalExGifts >= ctx.gift2ThresholdCents;

  const liveMax   = tier2 ? ctx.max2 : (tier1 ? ctx.max1 : 0);
  const progTotal = Math.max(ctx.gift2ThresholdCents || 1, 1);
  const clamped   = Math.min(subtotalExGifts, progTotal);
  const pct       = (clamped / progTotal) * 100;

  const haveGift  = giftCount > 0;
  const atMax     = giftCount >= liveMax;

  return {
    subtotalExGifts, pct, currency,
    awayShip, awayG1, awayG2,
    tier1, tier2, liveMax,
    haveGift, atMax, giftVariantIds,
    paidVariantIds // CHANGED: Return only paid variants
  };
}

  // ---------- Section Rendering API: refresh drawer contents ----------
async function refreshQuickCartDOM() {
  const container = document.querySelector('.quick-cart');
  const sectionId = container && container.dataset.sectionId;
  if (!container || !sectionId) return;

  const url = new URL(window.location.href);
  url.searchParams.set('sections', sectionId);

  const res  = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }});
  const data = await res.json();
  const html = data[sectionId] || data['quick-cart'];
  if (!html) return;

  const temp = document.createElement('div');
  temp.innerHTML = html;

  const replace = (sel) => {
    const src = temp.querySelector(sel);
    const dst = container.querySelector(sel);
    if (src && dst) dst.innerHTML = src.innerHTML;
  };
  
  replace('.quick-cart__header');
  
  // Only refresh the gift progress bar and items, NOT the entire main-content
  replace('.cart-progress');
  replace('.quick-cart__items');
  // Skip cross-sells section so theme JavaScript stays intact
  
  replace('.quick-cart__footer');

  // carry the busy state into the fresh DOM instantly
  applyBusyState(container);

  // Light-touch: just (re)bind carousel (guarded) and resync once
  initGiftCarousel();
  debouncedSync();
  
  // Trigger theme event so cross-sells can re-init if needed
  document.dispatchEvent(new CustomEvent('theme:cart:refresh', { 
    bubbles: true 
  }));
}
  // ---------- add / remove ----------
  async function addGift(variantId) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: { _gift: 'true' }
      })
    });
    // No manual cart:updated dispatch here — we refresh/sync ourselves.
  }

  // Remove gifts when thresholds unmet (requires snippet/ctx to compute)
 async function removeGiftsIfNotEligible() {
  const ctx = getContext();
  if (!ctx) return;

  try {
    const cart  = await fetchCart();
    const state = calcFromCart(cart, ctx);

    // If we’re at/above Tier 1, gifts are allowed.
    if (state.tier1) {
      // But enforce the current max for the active tier.
      await trimGiftsToMax(cart, ctx);
      return;
    }

    // Below Tier 1: remove all gifts.
    const removed = await removeAllGiftsViaChange(cart);
    if (removed) await refreshQuickCartDOM();
  } catch (err) {
    console.error('removeGiftsIfNotEligible failed:', err);
  } finally {
    debouncedSync();
  }
}


  // Remove gifts if ONLY gifts remain, or if cart total is 0 with gift lines
  async function removeGiftsIfOnlyGiftsRemain() {
    try {
      const cart = await fetchCart();
      const items = cart.items || [];
      if (!items.length) return;

      const hasPaid = items.some(i => !(i.properties && i.properties._gift === 'true') && i.final_line_price > 0);
      const hasGift = items.some(i => i.properties && i.properties._gift === 'true');

      if (hasPaid) return;

      if (hasGift || (cart.total_price === 0 && items.length === 1)) {
        const removed = await removeAllGiftsViaChange(cart);
        if (removed) await refreshQuickCartDOM();
      }
    } catch (err) {
      console.error('removeGiftsIfOnlyGiftsRemain failed:', err);
    }
  }

  // ---------- render ----------
  function renderProgress(ctx, state) {
  ctx.fillEl.style.width = `${Math.max(0, Math.min(100, state.pct))}%`;

  // reflect tier on DOM (used by CSS to show/hide gifts row)
  ctx.giftsWrap.dataset.max = String(state.liveMax || 0);
  ctx.giftsWrap.dataset.eligible = state.tier1 ? 'true' : 'false';

  let html;
  if (state.subtotalExGifts < ctx.shipThresholdCents) {
    html = `Only <strong>${formatMoneyIntl(state.awayShip, state.currency)}</strong> away from free shipping!`;
  } else if (!state.tier1) {
    // Free shipping but below Tier-1
    html = `<strong>Free shipping unlocked</strong> • Only <strong>${formatMoneyIntl(state.awayG1, state.currency)}</strong> away from <strong>your first free gift</strong>`;
  } else if (!state.tier2) {
    // Tier-1 reached (even if a gift is already selected): push toward Tier-2
    html = `<strong>1 free gift unlocked</strong> — spend <strong>${formatMoneyIntl(state.awayG2, state.currency)}</strong> more to unlock <strong>more free gifts</strong>.`;
  } else {
    // Tier-2
    html = `<strong>You’ve unlocked ${state.liveMax} free gifts</strong> — choose up to ${state.liveMax}.`;
  }

  ctx.labelEl.innerHTML = html;

  const giftPin = ctx.root.querySelector('[data-gift-pin]');
  if (giftPin) giftPin.setAttribute('data-active', state.tier1 ? 'true' : 'false');
}



function renderGiftButtons(ctx, state) {
  if (giftsBusy) {
    $$('[data-add-gift]', ctx.giftsWrap).forEach(b => {
      b.disabled = true;
      b.classList.add('gift-is-disabled');
      b.setAttribute('aria-disabled', 'true');
    });
    return;
  }
  
  const btns = $$('[data-add-gift]', ctx.giftsWrap);
  btns.forEach(btn => {
    const vid = Number(btn.getAttribute('data-variant'));
    const isGift = state.giftVariantIds.has(vid);
    const isPaidInCart = state.paidVariantIds.has(vid);
    
    const card = btn.closest('.cart-gifts__item');
    
    if (isPaidInCart && card) {
      card.style.display = 'none';
      return;
    } else if (card) {
      card.style.display = '';
    }
    
    const disable = !state.tier1 || state.atMax || isGift || !vid;

    btn.disabled = disable;
    btn.classList.toggle('gift-is-disabled', disable);

    let text = 'Add gift';
    if (!state.tier1) text = 'Add gift (locked)';
    if (state.atMax && state.tier1) text = 'Limit reached';
    if (isGift) text = 'Added';
    if (btn.textContent.trim() !== text) btn.textContent = text;
  });
}

// Hide gift carousel entirely if all gifts are in cart as paid items
function hideCarouselIfAllInCart(ctx, state) {
  const cards = $$('.cart-gifts__item', ctx.giftsWrap);
  const visibleCards = cards.filter(card => card.style.display !== 'none');
  
  // If no cards visible, hide the entire carousel
  if (cards.length > 0 && visibleCards.length === 0) {
    ctx.giftsWrap.style.display = 'none';
  } else {
    ctx.giftsWrap.style.display = '';
  }
}


  // ---------- sync ----------
  async function syncUI() {
  const ctx = getContext();
  if (!ctx) {
    await removeGiftsIfOnlyGiftsRemain();
    return;
  }

  const cart  = await fetchCart();
  const state = calcFromCart(cart, ctx);

  renderProgress(ctx, state);
  renderGiftButtons(ctx, state);
  hideCarouselIfAllInCart(ctx, state); // NEW: Hide carousel if all gifts are in cart

  if (!state.tier1 && state.haveGift) { // Fixed from !state.eligible
    await removeGiftsIfNotEligible();
  }
}

  const debouncedSync               = debounce(syncUI, 120);
  const debouncedEnforceBelowThresh = debounce(removeGiftsIfNotEligible, 140);
  const debouncedEnforceOnlyGifts   = debounce(removeGiftsIfOnlyGiftsRemain, 140);

  // 2) ONE debounced post-mutation pass (no triple setTimeout)
  const schedulePostCartChangeChecks = (() => {
    const run = () => { debouncedEnforceOnlyGifts(); debouncedEnforceBelowThresh(); debouncedSync(); };
    return debounce(run, 80);
  })();

  // 5) Use only the fetch interceptor (remove XHR wrapper)
  try {
    const _fetch = window.fetch;
    window.fetch = function (...args) {
      const url = (typeof args[0] === 'string') ? args[0] : (args[0] && args[0].url);
      const isCartMutation = /\/cart\/(change|update|add)\.js(\?|$)/.test(url || '');
      const p = _fetch.apply(this, args);
      if (isCartMutation) p.then(() => schedulePostCartChangeChecks()).catch(() => {});
      return p;
    };
  } catch (e) {}

  // Gift helpers
  function isGiftLine(i) { return i && i.properties && i.properties._gift === 'true'; }

// Update the setGiftMaxAttribute function to accept 0 or null for clearing
let lastSentMax = null;
async function setGiftMaxAttribute(max) {
  const safe = max === null ? 0 : Math.max(0, Number(max) || 0);
  if (lastSentMax === safe) return;
  lastSentMax = safe;
  
  // If max is 0, clear the attribute entirely
  if (safe === 0) {
    await fetch('/cart/update.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json','Accept':'application/json' },
      body: JSON.stringify({ attributes: { _gift_max: '' } }) // Empty string removes it
    });
  } else {
    await fetch('/cart/update.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json','Accept':'application/json' },
      body: JSON.stringify({ attributes: { _gift_max: String(safe) } })
    });
  }
}

async function removeAllGiftsViaChange(cart) {
  const items = (cart && cart.items) || [];
  const giftKeys = items.filter(isGiftLine).map(i => i.key);
  if (!giftKeys.length) return false;

  for (const key of giftKeys) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }
  
  // Clear the attribute after removing all gifts
  await setGiftMaxAttribute(0);
  
  return true;
}

  function scheduleEdgeCaseCleanupAndReload() {
    const run = async () => {
      try {
        const cart = await fetchCart();
        const items = cart.items || [];
        if (!items.length) return;

        const hasPaid = items.some(i => !isGiftLine(i) && i.final_line_price > 0);
        const hasGift = items.some(isGiftLine);

        if (hasGift && !hasPaid) {
          const removed = await removeAllGiftsViaChange(cart);
          if (removed) {
            await refreshQuickCartDOM();
            setTimeout(() => { window.location.reload(); }, 1500);
          }
        }
      } catch (e) {
        console.error('edgeCaseCleanup failed:', e);
      }
    };

    setTimeout(run, 120);
    setTimeout(run, 360);
    setTimeout(run, 900);
  }
// --- replace the old pointerdown that called setGiftsBusy(true, btn) ---
let armX = 0, armY = 0;

function clearArmedBusy() {
  // we never set data-busy on pointerdown anymore, but make sure nothing is stuck
  const ctx = getContext();
  if (ctx) {
    ctx.giftsWrap.removeAttribute('data-busy');
    $$('[data-add-gift][data-busy-exempt]', ctx.giftsWrap)
      .forEach(b => b.removeAttribute('data-busy-exempt'));
  }
  giftAddLock = false;
  lockedBtn   = null;
}

document.addEventListener('pointerdown', (e) => {
  const btn = e.target.closest('[data-add-gift]');
  if (!btn) return;
  if (btn.disabled || btn.classList.contains('is-disabled')) return;

  // Just remember which button started the gesture; do NOT set data-busy here.
  giftAddLock = true;
  lockedBtn   = btn;
  armX = e.clientX; armY = e.clientY;
}, true);

// If the gesture becomes a scroll/drag, cancel the armed state
document.addEventListener('pointermove', (e) => {
  if (!lockedBtn) return;
  if (Math.abs(e.clientX - armX) > 8 || Math.abs(e.clientY - armY) > 8) {
    clearArmedBusy();
  }
}, { passive: true });

document.addEventListener('pointerup', clearArmedBusy, true);
document.addEventListener('pointercancel', clearArmedBusy, true);


  // ---------- events ----------
  // Add gift (click) — trim to max only here (not on every cart event)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-gift]');
    if (!btn) return;
    if (btn.disabled || giftsBusy) return;

    const variantId = btn.getAttribute('data-variant');
    if (!variantId) return;

    try {
      giftsBusy = true;
      applyBusyState();

      await addGift(variantId);

      // Safety net: if two adds slipped through anyway, trim back to max
      const ctx = getContext();
      if (ctx) {
        const cart = await fetchCart();
        await trimGiftsToMax(cart, ctx);
      }

      await refreshQuickCartDOM(); // reflect gift
      debouncedSync();
    } catch (err) {
      console.error(err);
    } finally {
      giftsBusy = false;
      giftAddLock = false;
      lockedBtn = null;
      applyBusyState();
      debouncedSync();
    }
  });

  // Remove button click
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-remove-item]');
    if (!rm) return;

    setTimeout(() => {
      removeGiftsIfNotEligible();
      removeGiftsIfOnlyGiftsRemain();
      scheduleEdgeCaseCleanupAndReload();
      debouncedSync();
    }, 120);
  });

  // 3) Common cart events — keep light (no trim here)
  ;(['cart:updated','cart:update','cart:change','ajax:cart:update','theme:cart:updated']).forEach(ev => {
    document.addEventListener(ev, () => {
      debouncedEnforceBelowThresh();
      debouncedEnforceOnlyGifts();
      scheduleEdgeCaseCleanupAndReload();
      debouncedSync();
    });
  });

  // ---------- observers ----------
  let nodeObserver;
  function startNodeObserver() {
    if (nodeObserver) nodeObserver.disconnect();
    const root = $('.quick-cart');
    if (!root) return;
    nodeObserver = new MutationObserver(debounce(() => {
      // single pass; sync decides what else is needed
      debouncedSync();
      initGiftCarousel(); // safe (guarded)
    }, 120));
    nodeObserver.observe(root, { childList: true, subtree: true });
  }

  let docObserverStarted = false;
  function startDocObserver() {
    if (docObserverStarted) return;
    const docObserver = new MutationObserver(debounce(() => {
      if ($('.quick-cart')) {
        startNodeObserver();
        debouncedSync();
      }
    }, 120));
    docObserver.observe(document.documentElement, { childList: true, subtree: true });
    docObserverStarted = true;
  }

  // ---------- boot ----------
  document.addEventListener('DOMContentLoaded', () => {
    startDocObserver();
    startNodeObserver();
    initGiftCarousel();
    debouncedSync();
    debouncedEnforceBelowThresh();
    debouncedEnforceOnlyGifts();
  });

  // Safety: in case the drawer mounts later (lazy/portal)
  setTimeout(() => { startDocObserver(); startNodeObserver(); debouncedSync(); }, 350);
})();
